import React from 'react'
import { theme } from '../theme'
import Layout from '../components/layout'
import { Container, StickerAnimation } from '../components'
import styled from 'react-emotion'

const CenterTitle = styled('h2')`
  font-size: 2em;
  text-align: center;
  display: block;
`

const StickerAnimationContainer = styled('div')`
  width: 300px;
  height: 300px;
  margin-right: auto;
  margin-left: auto;
  transform: translate3d(0, 0, 0);
`

const SupportEmail = () => (
  <a href="mailto:help@slapstick.app">help@slapstick.app</a>
)

const FAQPage = () => (
  <Layout backgroundColor={theme.fg} pageTitle="Submitted Content Usage Terms">
    <Container role="main">
      <CenterTitle>
        Slapstick Submitted
        <br />
        Content Usage Terms
      </CenterTitle>
      <p>Last modified: August 03, 2018</p>
      <p>
        By submitting content to us or by giving us permission to use your
        content on our application and/or website:
      </p>
      <ul>
        <li>You represent and warrant that you are at least 18 years old.</li>
        <li>
          You grant to Buck Design, LLC and its affiliates ("
          <b>Buck</b>
          ") and its sublicensees a nonexclusive, royalty-free, perpetual,
          revocable, and fully sublicensable right to use, reproduce, modify,
          adapt, publish, translate, create derivative works from, distribute,
          and display your content throughout the world in any media. You also
          grant to Buck and its sublicensees the right to use the name and
          social media user profile associated with your content. For purposes
          of this agreement, "content" means photographs, text, graphics, moving
          images, sound, illustrations or any other materials, including any
          associated metadata or location information made available by or
          through the social media platforms from which we access your content.
        </li>
        <li>
          You represent and warrant that you own or otherwise control all of the
          rights to your content; that the content is accurate; that use of the
          content you supply will not cause injury to any person or entity; and
          that you will indemnify Buck for all claims resulting from content you
          supply. Buck takes no responsibility and assumes no liability for any
          content you supply.
        </li>
        <li>
          You understand that you will not be paid for Buck's use of your
          content.
        </li>
        <li>
          Buck respects the intellectual property of others. If you want Buck to
          stop using your content, please submit a request to <SupportEmail />{' '}
          and we will stop using your content within 30 days. If you believe
          that your content has been copied in a way that constitutes copyright
          infringement, you may notify us by providing the following information
          (as required by the Online Copyright Infringement Liability Limitation
          Act of the Digital Millennium Copyright Act (“
          <b>DMCA</b>
          ”), 17 U.S.C. sec. 512):
        </li>
        <li>
          A physical or electronic signature of the person authorized to act on
          behalf of the owner of an exclusive right that is allegedly infringed;
        </li>
        <li>
          Identification of the copyrighted work claimed to have been infringed,
          or if multiple copyrighted works are covered by a single notification,
          a representative list of such works;{' '}
        </li>
        <li>
          Identification of the material that is claimed to be infringing or to
          be the subject of infringing activity and that is to be removed or
          access to which is to be disabled, and information reasonably
          sufficient to permit us to locate the material;
        </li>
        <li>
          Information reasonably sufficient to permit us to contact you, such as
          an address, telephone number, and if available, an e-mail address;
        </li>
        <li>
          A statement that you have a good faith belief that use of the material
          in the manner complained of is not authorized by you, your agent, or
          the law; and{' '}
        </li>
        <li>
          A statement that the information in the notification is accurate, and,
          under penalty of perjury, that you are authorized to act on behalf of
          the owner of an exclusive right that is allegedly infringed.
        </li>
      </ul>
      <p>
        Please send the written communication to our copyright agent by e-mail
        AND by U.S. Mail to:
      </p>
      <p>
        Buck Design
        <br />
        2630 Lacy St
        <br />
        Los Angeles CA 90031
        <br />
        Attn: Compliance Manager
        <br />
        Email: hello@slapstick.app
        <br />
        Email Subject: “DMCA Request”
      </p>
      <p>
        Any dispute or claim relating in any way to your content will be
        resolved by binding arbitration, rather than in court, except that you
        may assert claims in small claims court if your claims qualify. The
        Federal Arbitration Act and federal arbitration law apply to this
        agreement. There is no judge or jury in arbitration, and court review of
        an arbitration award is limited. However, an arbitrator can award on an
        individual basis the same damages and relief as a court (including
        injunctive and declaratory relief or statutory damages), and must follow
        the terms of this agreement as a court would. To begin an arbitration
        proceeding, you must send a letter requesting arbitration and describing
        your claim to our registered agent at 2630 Lacy St, Los Angeles CA
        90031. The arbitration will be conducted by the American Arbitration
        Association (AAA) under its rules, including the AAA's Supplementary
        Procedures for Consumer-Related Disputes. The AAA's rules are available
        at www.adr.org or by calling 1-800-778-7879. Payment of all filing,
        administration and arbitrator fees will be governed by the AAA's rules.
        You may choose to have the arbitration conducted by telephone, based on
        written submissions, or in person in the county where you live or at
        another mutually agreed location. We each agree that any dispute
        resolution proceedings will be conducted only on an individual basis and
        not in a class, consolidated or representative action. If for any reason
        a claim proceeds in court rather than in arbitration we each waive any
        right to a jury trial. We also both agree that you or we may bring suit
        in court to enjoin infringement or other misuse of intellectual property
        rights.
      </p>
      <StickerAnimationContainer>
        <StickerAnimation
          // poster="/yay-sticker.svg"
          apng="/stickers/arms-selfie-loop.apng"
        />
      </StickerAnimationContainer>
    </Container>
  </Layout>
)

export default FAQPage
